import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";

import { request } from "../request/request";

const initialState = {
    categories: [],
    loadingStatus: "idle",
    error: null
}

export const fetchVehiclesFields = createAsyncThunk(
    'vehiclesFields/fetchVehiclesFields',
    async ({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/vehicles/create`,
                'GET',
                null,
                customHeaders
            )

            return response;
        } catch (error) {
            rejectWithValue(error.status);
        }
    }
)

const vehiclesCreateSlice = createSlice({
    name: 'vehiclesFields',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehiclesFields.pending, (state) => {
                state.categories = [];
                state.loadingStatus = "loading";
                state.error = null
            })
            .addCase(fetchVehiclesFields.fulfilled, (state, action) => {
                state.categories = action.payload?.categories || [];
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchVehiclesFields.rejected, (state, action) => {
                state.categories = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default vehiclesCreateSlice.reducer;